let messaages_fr = {
	Salutation: {
		required: 'Veuillez sélectionner une salutation.',
	},
	FirstName: {
		required: 'Veuillez saisir un prénom.',
	},
	LastName: {
		required: 'Veuillez saisir un nom de famille.',
	},
	Email: {
		required: 'Veuillez saisir une adresse e-mail.',
		email: 'Veuillez saisir une adresse e-mail valide.',
	},
	Country: {
		required: 'Veuillez saisir un code postal',
	},
	Postcode: {
		required: 'Bitte wählen Sie eine Postleitzahl aus.',
	},
	Password: {
		required: 'Veuillez saisir un mot de passe.',
	},
	ConfirmPassword: {
		required: 'Veuillez saisir un mot de passe pour le confirmer.',
		equalTo: 'Veuillez vous assurer que les mots de passe correspondent.',
	},
	TermsAndConditions: {
		required: 'Veuillez accepter les termes et conditions.',
	}
};

export function messages_fr() {
	return messaages_fr;
}
